import styles from './EmptyState.module.css';

/**
 * Empty state.
 *
 * Always offers a next action rather than leaving the user at a dead end.
 */
export function EmptyState({ icon, title, description, action, secondaryAction, className = '' }) {
  return (
    <div className={`${styles.container} ${className}`}>
      {icon && (
        <div className={styles.icon} aria-hidden="true">
          {icon}
        </div>
      )}
      <h2 className={styles.title}>{title}</h2>
      {description && <p className={styles.description}>{description}</p>}
      {(action || secondaryAction) && (
        <div className={styles.actions}>
          {action}
          {secondaryAction}
        </div>
      )}
    </div>
  );
}
